(function () {
  if (window.CleerdentStickyAtc && window.CleerdentStickyAtc.initialized) return;

  var state = {
    initialized: true,
    bars: []
  };

  function getRoot(bar) {
    var selector = bar.getAttribute('data-root-selector');
    return selector ? document.querySelector(selector) : null;
  }

  function getScopedNodes(bar, selector) {
    if (!selector) return [];
    var nodes = [];
    var root = getRoot(bar);

    if (root) nodes = nodes.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll(selector)));

    return nodes.filter(function (node, index, list) {
      return node && list.indexOf(node) === index;
    });
  }

  function isNodeVisible(node) {
    if (!node || node.nodeType !== 1) return false;
    if (!node.getClientRects || node.getClientRects().length === 0) return false;

    var current = node;
    while (current && current.nodeType === 1) {
      var styles = window.getComputedStyle(current);
      if (styles.display === 'none' || styles.visibility === 'hidden' || styles.visibility === 'collapse') return false;
      current = current.parentElement;
    }

    return true;
  }

  function getScopedNode(bar, selector, preferVisible, requireVisible) {
    var nodes = getScopedNodes(bar, selector);
    if (!nodes.length) return null;

    if (preferVisible || requireVisible) {
      for (var i = 0; i < nodes.length; i += 1) {
        if (isNodeVisible(nodes[i])) return nodes[i];
      }
    }

    return requireVisible ? null : (nodes[0] || null);
  }

  function getForm(bar) {
    return getScopedNode(bar, bar.getAttribute('data-form-selector'), true, false);
  }

  function getTrigger(bar) {
    return getScopedNode(bar, bar.getAttribute('data-trigger-selector'), true, true);
  }

  function getClickTarget(bar) {
    return getScopedNode(bar, bar.getAttribute('data-click-selector'), true, true);
  }


  function getSubmitButton(form) {
    if (!form) return null;
    var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"], [data-atc-form], [data-cd-tb-atc], [data-cd-refill-atc]'));
    for (var i = 0; i < buttons.length; i += 1) {
      if (isNodeVisible(buttons[i])) return buttons[i];
    }
    return buttons[0] || null;
  }

  function getActiveVariantNode(root) {
    if (!root) return null;
    return root.querySelector('.is-active[data-variant-id], .is-active[data-cd-tb-variant], .is-active[data-cd-refill-variant]');
  }

  function getVariantAvailable(node) {
    if (!node) return null;

    if (node.hasAttribute('data-variant-available')) return node.getAttribute('data-variant-available') !== 'false';
    if (node.hasAttribute('data-cd-tb-available')) return node.getAttribute('data-cd-tb-available') !== 'false';
    if (node.hasAttribute('data-cd-refill-available')) return node.getAttribute('data-cd-refill-available') !== 'false';

    return null;
  }

  function getVariantPrice(node) {
    if (!node) return '';
    return node.getAttribute('data-variant-price') || node.getAttribute('data-cd-tb-price') || node.getAttribute('data-cd-refill-price') || '';
  }

  function getVariantCompare(node) {
    if (!node) return '';
    return node.getAttribute('data-variant-compare') || node.getAttribute('data-cd-tb-compare') || node.getAttribute('data-cd-refill-compare') || '';
  }

  function getVariantImage(node) {
    if (!node) return '';
    return node.getAttribute('data-variant-image') || node.getAttribute('data-cd-tb-image-src') || node.getAttribute('data-cd-refill-image-src') || node.getAttribute('data-cd-refill-mobile-image-src') || '';
  }

  function getVariantId(node) {
    if (!node) return '';
    return node.getAttribute('data-variant-id') || node.getAttribute('data-cd-tb-variant') || node.getAttribute('data-cd-refill-variant') || '';
  }

  function getVariantLabel(node) {
    if (!node) return '';
    return node.getAttribute('aria-label') || node.getAttribute('title') || textFromNode(node) || 'Variant';
  }

  function isTransparentColor(value) {
    var color = String(value || '').replace(/\s+/g, '').toLowerCase();
    return !color || color === 'transparent' || color === 'rgba(0,0,0,0)';
  }

  function getVariantVisual(node) {
    var core = node && node.querySelector ? node.querySelector('.cd-pdp-hero__swatch-core') : null;
    var target = core || node;
    var color = '';
    var image = '';

    if (node) {
      color = node.getAttribute('data-variant-swatch') ||
        node.style.getPropertyValue('--cd-tb-swatch') ||
        node.style.getPropertyValue('--cd-rh-swatch') ||
        '';
      image = node.getAttribute('data-variant-swatch-image') || '';
    }

    if (core) {
      color = color || core.style.getPropertyValue('--swatch-fill') || '';
      image = image || core.getAttribute('data-swatch-image') || '';
    }

    if (target && window.getComputedStyle) {
      var styles = window.getComputedStyle(target);
      if (!color || isTransparentColor(color)) color = styles.backgroundColor || '';
      if (!image && styles.backgroundImage && styles.backgroundImage !== 'none') image = styles.backgroundImage;
    }

    if (node && window.getComputedStyle && (!color || isTransparentColor(color)) && !image) {
      var beforeStyles = window.getComputedStyle(node, '::before');
      color = beforeStyles.backgroundColor || color;
      if (beforeStyles.backgroundImage && beforeStyles.backgroundImage !== 'none') image = beforeStyles.backgroundImage;
    }

    if (image && image.indexOf('url(') !== 0 && image !== 'none') {
      image = 'url("' + String(image).replace(/"/g, '\\"') + '")';
    }

    return {
      color: isTransparentColor(color) ? '#dddddd' : color,
      image: image === 'none' ? '' : image
    };
  }

  function getSourceVariantNodes(bar) {
    var root = getRoot(bar);
    var selector = bar.getAttribute('data-variant-selector');
    if (!root || !selector) return [];

    var all = Array.prototype.slice.call(root.querySelectorAll(selector));
    var unique = [];
    var seen = {};

    all.forEach(function (node) {
      var variantId = getVariantId(node);
      if (!variantId || seen[variantId]) return;
      seen[variantId] = true;
      unique.push(node);
    });

    return unique;
  }

  function getSourceVariantNode(bar, variantId) {
    var root = getRoot(bar);
    var selector = bar.getAttribute('data-variant-selector');
    if (!root || !selector || !variantId) return null;

    var matches = Array.prototype.slice.call(root.querySelectorAll(selector)).filter(function (node) {
      return getVariantId(node) === String(variantId);
    });

    for (var i = 0; i < matches.length; i += 1) {
      if (isNodeVisible(matches[i])) return matches[i];
    }

    return matches[0] || null;
  }

  function syncStickyVariantPicker(bar, preferredVariantId) {
    var picker = bar.querySelector('[data-cd-sticky-atc-variants]');
    if (!picker) return;

    var sourceNodes = getSourceVariantNodes(bar);
    if (sourceNodes.length <= 1) {
      picker.hidden = true;
      picker.innerHTML = '';
      picker.removeAttribute('data-variant-signature');
      return;
    }

    var signature = sourceNodes.map(getVariantId).join('|');
    if (picker.getAttribute('data-variant-signature') !== signature) {
      picker.innerHTML = '';

      sourceNodes.forEach(function (source) {
        var variantId = getVariantId(source);
        var label = getVariantLabel(source);
        var button = document.createElement('button');
        var core = document.createElement('span');
        var hiddenLabel = document.createElement('span');

        button.type = 'button';
        button.className = 'cd-sticky-atc__variant';
        button.setAttribute('data-cd-sticky-atc-variant', variantId);
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
        core.className = 'cd-sticky-atc__variant-core';
        hiddenLabel.className = 'cd-sticky-atc__variant-label';
        hiddenLabel.textContent = label;
        button.appendChild(core);
        button.appendChild(hiddenLabel);
        picker.appendChild(button);
      });

      picker.setAttribute('data-variant-signature', signature);
    }

    var activeVariant = preferredVariantId || getVariantId(getActiveVariantNode(getRoot(bar)));
    Array.prototype.forEach.call(picker.querySelectorAll('[data-cd-sticky-atc-variant]'), function (button) {
      var variantId = button.getAttribute('data-cd-sticky-atc-variant');
      var source = getSourceVariantNode(bar, variantId);
      var visual = source ? getVariantVisual(source) : { color: '#dddddd', image: '' };
      var core = button.querySelector('.cd-sticky-atc__variant-core');
      var isActive = String(variantId) === String(activeVariant);
      var isAvailable = source ? getVariantAvailable(source) !== false : true;

      button.classList.toggle('is-active', isActive);
      button.classList.toggle('is-unavailable', !isAvailable);
      button.setAttribute('aria-checked', isActive ? 'true' : 'false');
      if (core) {
        core.style.backgroundColor = visual.color;
        core.style.backgroundImage = visual.image;
      }
    });

    picker.hidden = false;
  }

  function textFromNode(node) {
    return node ? (node.textContent || '').trim() : '';
  }


  function detailValue(detail, keys) {
    if (!detail) return { exists: false, value: '' };
    for (var i = 0; i < keys.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(detail, keys[i])) {
        return { exists: true, value: detail[keys[i]] };
      }
    }
    return { exists: false, value: '' };
  }

  function cleanPurchasePrice(value) {
    var text = String(value || '').replace(/^\s*US\s*/i, '').replace(/\s+/g, '').trim();
    return /[0-9]/.test(text) ? text : '';
  }

  function readPurchasePriceNode(node) {
    if (!node) return '';
    return cleanPurchasePrice(
      (node.getAttribute && (node.getAttribute('data-sls-price') || node.getAttribute('data-price'))) ||
      node.textContent ||
      ''
    );
  }

  function getSelectedPurchaseOption(root) {
    if (!root) return null;

    var checkedInput = root.querySelector(
      '.sls-option-container input[type="radio"]:checked, .sls-option-container input[type="checkbox"]:checked, .sls-option-container input:checked'
    );
    var checkedOption = checkedInput && checkedInput.closest ? checkedInput.closest('.sls-option-container') : null;
    if (checkedOption) return checkedOption;

    return root.querySelector(
      '.sls-option-container.sls-active, .sls-option-container.sls-selected, .sls-option-container.is-selected, .sls-option-container.selected, .seal-row.sls-active, .seal-row.seal-selected'
    );
  }

  function getSelectedPurchasePrice(root) {
    var option = getSelectedPurchaseOption(root);
    if (!option) return '';

    var selectors = [
      '.sls-selling-plan-group-price .money',
      '.sls-total-price .money',
      '.sls-price .money',
      '.seal-money',
      '.ht-money',
      '.sls-selling-plan-group-price',
      '.sls-total-price',
      '.sls-price',
      '[data-sls-price]',
      '[data-price]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var priceNode = option.querySelector(selectors[i]);
      var price = readPurchasePriceNode(priceNode);
      if (price) return price;
    }

    return '';
  }

  function setLoading(bar, isLoading) {
    bar.classList.toggle('is-loading', !!isLoading);
    var button = bar.querySelector('[data-cd-sticky-atc-button]');
    if (button) button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function refreshBar(bar, detail) {
    var root = getRoot(bar);
    var form = getForm(bar);
    var trigger = getTrigger(bar);
    var clickTarget = getClickTarget(bar);
    var activeVariant = getActiveVariantNode(root);
    var detailVariant = detailValue(detail, ['variantId', 'variant_id', 'id']);
    var priceNode = getScopedNode(bar, bar.getAttribute('data-price-selector'), true);
    var compareNode = getScopedNode(bar, bar.getAttribute('data-compare-selector'), true);
    var imageNode = getScopedNode(bar, bar.getAttribute('data-image-selector'), true);

    var detailPrice = detailValue(detail, ['price', 'finalPrice', 'final_price', 'sellingPlanPrice', 'selling_plan_price']);
    var detailCompare = detailValue(detail, ['compareAtPrice', 'compare_at_price', 'compare', 'comparePrice']);
    var purchasePrice = getSelectedPurchasePrice(root);
    var domPrice = textFromNode(priceNode);
    var domCompare = textFromNode(compareNode);

    var price = (detailPrice.exists && detailPrice.value) || purchasePrice || domPrice || getVariantPrice(activeVariant);
    var compare = detailCompare.exists ? (detailCompare.value || '') : (purchasePrice ? '' : (compareNode ? domCompare : getVariantCompare(activeVariant)));
    var available = detail && typeof detail.available !== 'undefined' ? !!detail.available : getVariantAvailable(activeVariant);
    var stickyPrice = bar.querySelector('[data-cd-sticky-atc-price]');
    var stickyCompare = bar.querySelector('[data-cd-sticky-atc-compare]');
    var stickyImage = bar.querySelector('[data-cd-sticky-atc-image]');
    var stickyButton = bar.querySelector('[data-cd-sticky-atc-button]');
    var stickyButtonText = bar.querySelector('[data-cd-sticky-atc-button-text]');

    syncStickyVariantPicker(bar, detailVariant.exists ? detailVariant.value : getVariantId(activeVariant));

    if (price && stickyPrice) stickyPrice.textContent = price;

    if (stickyCompare) {
      if (compare) {
        stickyCompare.textContent = compare;
        stickyCompare.classList.remove('is-hidden');
      } else {
        stickyCompare.textContent = '';
        stickyCompare.classList.add('is-hidden');
      }
    }

    var nextImage = (detail && detail.image) || getVariantImage(activeVariant) || (imageNode && (imageNode.currentSrc || imageNode.src));
    if (stickyImage && nextImage && stickyImage.src !== nextImage) {
      stickyImage.src = nextImage;
    }

    if (stickyImage && imageNode && imageNode.alt) {
      stickyImage.alt = imageNode.alt;
    }

    if (stickyButton) {
      var submitButton = getSubmitButton(form) || trigger;
      var labelSource = clickTarget || submitButton || trigger;
      var isDisabled = available === false || (labelSource && labelSource.disabled) || (!labelSource && submitButton && submitButton.disabled);
      stickyButton.disabled = !!isDisabled;

      if (stickyButtonText && available !== false) {
        var label = textFromNode(labelSource) || bar.getAttribute('data-default-label') || stickyButtonText.textContent.trim();
        if (label) stickyButtonText.textContent = label;
      }

      if (stickyButtonText && available === false) {
        stickyButtonText.textContent = stickyButtonText.getAttribute('data-sold-out-label') || 'Sold out';
      }
    }
  }

  function hideBar(bar) {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  function updateVisibility(bar) {
    var trigger = getTrigger(bar);
    var form = getForm(bar);

    if (!trigger && form) trigger = getSubmitButton(form);
    if (!trigger || !isNodeVisible(trigger)) {
      hideBar(bar);
      return;
    }

    var rect = trigger.getBoundingClientRect();
    var show = rect.bottom <= 0;

    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function clickOriginalTarget(bar) {
    var clickTarget = getClickTarget(bar);
    if (!clickTarget || clickTarget.disabled) return false;

    var rect = clickTarget.getBoundingClientRect();
    var isDesktopSubscriptionTrigger = clickTarget.matches && clickTarget.matches('[data-cd-tb-buy-trigger]') && window.matchMedia('(min-width: 750px)').matches;
    var isOffscreen = rect.bottom < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight || 0);
    var root = getRoot(bar);
    var openedPurchaseOptions = root && root.getAttribute('data-cd-has-purchase-options') === 'true';

    if (!openedPurchaseOptions) setLoading(bar, true);

    clickTarget.click();

    if (isDesktopSubscriptionTrigger && isOffscreen && typeof clickTarget.scrollIntoView === 'function') {
      clickTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (openedPurchaseOptions) {
      setLoading(bar, false);
      window.setTimeout(function () {
        refreshBar(bar);
        updateVisibility(bar);
      }, 80);
    }
    return true;
  }

  function submitOriginalForm(bar) {
    var form = getForm(bar);
    var button = bar.querySelector('[data-cd-sticky-atc-button]');
    var submitButton = getSubmitButton(form);

    if (!button || button.disabled) return;

    if (clickOriginalTarget(bar)) return;

    if (!form) return;

    setLoading(bar, true);

    if (submitButton && submitButton.disabled) {
      setLoading(bar, false);
      return;
    }

    if (submitButton && typeof submitButton.click === 'function' && isNodeVisible(submitButton)) {
      submitButton.click();
    } else if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitButton || undefined);
    } else if (submitButton && typeof submitButton.click === 'function') {
      submitButton.click();
    } else {
      var event;
      try {
        event = new Event('submit', { bubbles: true, cancelable: true });
      } catch (error) {
        event = document.createEvent('Event');
        event.initEvent('submit', true, true);
      }

      if (form.dispatchEvent(event) && typeof form.submit === 'function') form.submit();
    }

    window.setTimeout(function () {
      setLoading(bar, false);
      refreshBar(bar);
    }, 5500);
  }

  function queueBarRefresh(bar) {
    if (!bar || bar._cdStickyAtcRefreshQueued) return;
    bar._cdStickyAtcRefreshQueued = true;
    window.requestAnimationFrame(function () {
      bar._cdStickyAtcRefreshQueued = false;
      refreshBar(bar);
      updateVisibility(bar);
    });
  }

  function queueBarRefreshCascade(bar) {
    queueBarRefresh(bar);
    window.setTimeout(function () { queueBarRefresh(bar); }, 90);
    window.setTimeout(function () { queueBarRefresh(bar); }, 240);
  }

  function isMutationRelevantToSticky(bar, mutation) {
    var priceSelector = bar.getAttribute('data-price-selector');
    var compareSelector = bar.getAttribute('data-compare-selector');
    var variantSelector = bar.getAttribute('data-variant-selector');
    var selectors = [
      priceSelector,
      compareSelector,
      variantSelector,
      '.sls-option-container',
      '.sls-price',
      '.sls-price .money',
      '.sls-selling-plan-group-price',
      '.sls-selling-plan-group-price .money',
      '.sls-total-price',
      '.sls-total-price .money',
      '.seal-money',
      '.ht-money',
      '[data-sls-price]',
      '[data-price]'
    ].filter(Boolean).join(',');

    if (!selectors) return false;

    var node = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
    if (node && node.matches && node.matches(selectors)) return true;
    if (node && node.closest && node.closest(selectors)) return true;

    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
      var added = mutation.addedNodes[i];
      if (added.nodeType !== 1) continue;
      if ((added.matches && added.matches(selectors)) || (added.querySelector && added.querySelector(selectors))) return true;
    }

    return false;
  }

  function bindBar(bar) {
    if (!bar || bar.dataset.cdStickyAtcBound === 'true') return;
    bar.dataset.cdStickyAtcBound = 'true';
    state.bars.push(bar);

    var root = getRoot(bar);
    var form = getForm(bar);
    var button = bar.querySelector('[data-cd-sticky-atc-button]');
    var variantPicker = bar.querySelector('[data-cd-sticky-atc-variants]');

    if (button) button.addEventListener('click', function () { submitOriginalForm(bar); });
    if (variantPicker) {
      variantPicker.addEventListener('click', function (event) {
        var stickyVariant = event.target.closest ? event.target.closest('[data-cd-sticky-atc-variant]') : null;
        if (!stickyVariant || !variantPicker.contains(stickyVariant)) return;

        var variantId = stickyVariant.getAttribute('data-cd-sticky-atc-variant');
        var source = getSourceVariantNode(bar, variantId);
        if (!source || source.disabled) return;

        syncStickyVariantPicker(bar, variantId);
        source.click();
        queueBarRefreshCascade(bar);
      });
    }

    if (root) {
      root.addEventListener('variant:change', function (event) {
        window.requestAnimationFrame(function () { refreshBar(bar, event.detail || {}); });
      });
      root.addEventListener('variant:changed', function (event) {
        window.requestAnimationFrame(function () { refreshBar(bar, event.detail || {}); });
      });
      root.addEventListener('change', function () {
        window.requestAnimationFrame(function () { refreshBar(bar); });
      }, true);
      root.addEventListener('click', function () {
        window.setTimeout(function () { refreshBar(bar); updateVisibility(bar); }, 80);
        window.setTimeout(function () { refreshBar(bar); updateVisibility(bar); }, 260);
      }, true);

      root.addEventListener('cleerdent:purchase-price-change', function (event) {
        refreshBar(bar, event.detail || {});
        updateVisibility(bar);
      });

      if (window.MutationObserver) {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i += 1) {
            if (isMutationRelevantToSticky(bar, mutations[i])) {
              queueBarRefreshCascade(bar);
              break;
            }
          }
        });

        observer.observe(root, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'checked', 'value', 'data-sls-price', 'data-price']
        });
        bar._cdStickyAtcObserver = observer;
      }
    }

    if (form) {
      form.addEventListener('submit', function () { setLoading(bar, true); }, true);
    }

    refreshBar(bar);
    updateVisibility(bar);
  }

  function refreshAll() {
    state.bars.forEach(function (bar) {
      refreshBar(bar);
      updateVisibility(bar);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cd-sticky-atc]'), bindBar);
    refreshAll();
  }

  var visibilityTicking = false;
  function queueVisibilityRefresh() {
    if (visibilityTicking) return;
    visibilityTicking = true;
    window.requestAnimationFrame(function () {
      visibilityTicking = false;
      state.bars.forEach(updateVisibility);
    });
  }

  ['cart:refresh', 'cart:updated', 'cart:update', 'theme:cart:change', 'ajaxProduct:added', 'product:added'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      state.bars.forEach(function (bar) {
        setLoading(bar, false);
        refreshBar(bar);
        updateVisibility(bar);
      });
    });
  });

  document.addEventListener('variant:change', function (event) {
    state.bars.forEach(function (bar) {
      var root = getRoot(bar);
      if (root && event.target && root.contains(event.target)) return;
      window.requestAnimationFrame(function () { refreshBar(bar, event.detail || {}); });
    });
  });

  window.addEventListener('scroll', queueVisibilityRefresh, { passive: true });
  window.addEventListener('resize', function () { window.setTimeout(refreshAll, 80); }, { passive: true });
  window.addEventListener('orientationchange', function () { window.setTimeout(refreshAll, 180); }, { passive: true });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 80); });
  document.addEventListener('shopify:section:unload', function (event) {
    state.bars = state.bars.filter(function (bar) {
      var shouldRemove = !!(event.target && event.target.contains(bar));
      if (shouldRemove && bar._cdStickyAtcObserver) bar._cdStickyAtcObserver.disconnect();
      return !shouldRemove;
    });
  });

  window.CleerdentStickyAtc = state;
  window.CleerdentStickyAtc.init = init;
  window.CleerdentStickyAtc.refresh = refreshAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
